import React, {Component} from 'react';
import $ from 'jquery';
import bhatia from '../assests/images/timeline/kes.png'
import uom from '../assests/images/timeline/uom.png'
import canada from '../assests/images/timeline/canada.png'
import yu from '../assests/images/timeline/yu.png'
import ibm from '../assests/images/timeline/ibm.png'
import naudix from '../assests/images/timeline/naudix.png'
import sapient from '../assests/images/timeline/sapient.png'
import udacity from '../assests/images/timeline/udacity.png'

function TimelineHeader(props){
	return 	<header className="timeline-header">
						<div className="tag is-black is-size-7-mobile is-size-6">{props.header}</div>
					</header>
}

function TimelineContent(props){

	if(props.device === 'desktop')
	{
		return <div className="timeline-item is-black">
							<div className="timeline-marker is-black">
							{/* <i className={props.marker}></i> */}
							</div>
							<div className="timeline-content">
								<article className="media">
									<div className="media-left has-text-right">
										
										<p className="heading is-size-7">{props.date}</p>
										<p className="has-text-weight-bold is-size-5-desktop">{props.name}</p> 
										<p className="has-text-weight-semibold">{props.content}</p>			
										<p className="has-text-weight-light">{props.location}</p>
									</div>
									<div className="media-content">
									<img className={props.imgClass} src={props.image}/>
									</div>
								</article>												
							</div>
						</div>
	}
	else {
		return 	<div className="timeline-item is-black">
							<div className="timeline-marker is-black">
							{/* <i className={props.marker}></i> */}
							</div>
							<div className="timeline-content">
								<article className="media">
									<div id="imageContent" className="media-left has-text-right">
										<img className={props.imgClass} src={props.image}/>	
									</div>
									<div id="mediaContent" className="media-content">					
										<p className="heading is-size-7">{props.date}</p>
										<p className="has-text-weight-bold is-size-5-desktop">{props.name}</p> 
										<p className="has-text-weight-semibold">{props.content}</p>			
										<p className="has-text-weight-light">{props.location}</p>
									</div>
								</article>												
							</div>
						</div>
	}
}

class Timeline extends Component {
	constructor() {
		super();
		this.state = {
			'device': $(window).width() < 1065 ? 'touch' : 'desktop',
		}
	}

	detectDevice() {
		this.setState({
			'device': $(window).width() < 1065 ? 'touch' : 'desktop'
		}, this.updateItems())
	}

	updateItems() {
		if(this.state.device === 'touch')
			$('#timelineContainer').attr('class', 'timeline');
		else 
			$('#timelineContainer').attr('class', 'timeline is-centered');
  }

  componentDidMount(){
    this.updateItems();
    // window.addEventListener("resize", this.updateItems.bind(this));
	}
	
	componentWillMount() {
		window.addEventListener("resize", this.detectDevice.bind(this));
		// window.addEventListener("resize", this.updateItems.bind(this));
	}

	render() {
		return (
			<div id="timeline" className="is-2-mobile">
			<section className="hero is-fullheight">
				<div className="column has-text-centered has-text-weight-bold">
					<p className="title is-5 is-blue has-text-bold padding-two-top is-heading">TIMELINE</p>
					<div className="columns is-centered">
						<div className="column is-6 has-text-centered">
							<p className="subtitle is-3 is-black has-text-bold">
								What have I been up to?
							</p>
							<p className="has-text-weight-light is-size-5">
								I've had the opportunity to work at and learn from some of the top
								software engineers at IBM, SapientRazorfish & Naudix AI
							</p>
						</div>
					</div>
				</div>
				
				<div className="hero-body">
					<div className="container">
						<div className="column">
							<div id="timelineContainer" className="timeline">
								{/* <TimelineHeader header="2010"/>
								<TimelineContent date="September 2010 - April 2012" name="T.P. Bhatia College of Science (High School)" content="Major - Computer Science" location="Mumbai, MH" image={bhatia} imgClass={'ui centered mini image padding-two-top'} marker={'fas fa-graduation-cap fa-lg'}/>

								<TimelineHeader header="2012"/>
								<TimelineContent device={this.state.device} date="September 2012 - April 2014" name="University of Mumbai - K.J. Somaiya College of Engineering" content="Major - Computer Engineering" location="Mumbai, MH" image={uom} imgClass={'ui centered mini image padding-two-top'} marker={'fas fa-graduation-cap'}/> */}

								<TimelineHeader header="2014"/>
								<TimelineContent date="July 2014" name="Arrived in Canada" location="Brampton, ON" image={canada} imgClass={'ui centered mini image padding-two-top'} marker={'fab fa-canadian-maple-leaf'}/>
								<TimelineContent device={this.state.device} date="September 2014 - April 2019" name="York University - Lassonde School of Engineering" content="Honors Bachelor of Science (HBSc) - Computer Science" location="Toronto, ON" image={yu} imgClass={'ui centered mini image padding-two-top'} marker={'fas fa-graduation-cap'}/>

								<TimelineHeader header="2016"/>
								<TimelineContent date="May 2016 - August 2017" name="IBM Canada" content="Software Developer Intern" location="Markham, ON" image={ibm} imgClass={'ui centered mini image padding-two-top'} marker={'fas fa-briefcase'}/>

								<TimelineHeader header="2018"/>
								<TimelineContent device={this.state.device} date="May 2018 - August 2018" name="Naudix AI" content="Full-Stack Developer Intern" location="Toronto, ON" image={naudix} imgClass={'ui centered mini image padding-two-top'} marker={'fas fa-briefcase'}/>
								<TimelineContent date="June 2018 - August 2018" name="Publicis.Sapient" content="Software Developer Intern" location="Toronto, ON" image={sapient} imgClass={'ui centered mini image padding-two-top'} marker={'fas fa-briefcase'}/>
								<TimelineContent device={this.state.device} date="November 2018 - January 2018" name="PyTorch Scholarship Challenge" content="PyTorch Scholar" location="Brampton, ON" image={udacity} imgClass={'ui centered mini image padding-two-top'} marker={'fas fa-briefcase'}/>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
		);
	}
};

export default Timeline;